<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Izaberite paritet"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
></kodit-dropdown>
